const addTagToTaxonomies = (tag) => ({
  type: 'ADD_TAG_TO_TAXONOMIES',
  tag,
});

export {
  addTagToTaxonomies,
};